import { useCallback } from 'react';
import type { Notification } from '@29100/shared';
import { api } from '../lib/api';
import { usePagedQuery, useQuery } from './useApi';

export function useNotifications(refreshKey = 0) {
  const query = useQuery<{ notifications: Notification[]; unreadCount: number }>(
    '/api/notifications',
    {},
    `notifications:${refreshKey}`,
  );

  const markRead = useCallback(
    (id: string) => api(`/api/notifications/${id}/read`, { method: 'POST' }),
    [],
  );
  const markAllRead = useCallback(() => api('/api/notifications/read-all', { method: 'POST' }), []);

  return { ...query, markRead, markAllRead };
}

/**
 * Auditoría del workspace.
 *
 * Es función de plan: los planes sin `audit_logs` reciben 403 y la pantalla
 * debe ofrecer mejorar de plan en lugar de mostrar un error.
 */
export function useActivity(workspaceId: string | null, refreshKey = 0) {
  // La API responde `{ activity }`.
  return usePagedQuery<unknown, { activity: unknown[]; nextOffset: number | null }>(
    workspaceId ? '/api/activity' : null,
    (respuesta) => respuesta.activity,
    { query: { workspaceId: workspaceId ?? '' } },
    `${workspaceId}:${refreshKey}`,
  );
}
